import React, { useState, useEffect } from "react";
import AdminNav from "../../navigation/AdminNav";
import { createDates, getDates, updateDates } from '../../actions/dates';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, CircularProgress, Button } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';

/**
 * This page presents the admin with a form to fill out to allow them to input what dates the progress presentation and demo day are
 * When the dates are submitted it will automatically show up on the screen which lets them know it submitted properly and sent to the dates
 * collection in the database.
 * If they already have submitted dates they are allowed to edit the dates.
 * @returns the dates form along with the dates that have been selected
 */

function AdminDates() {

    const [dates, setDates] = useState({
        progressDate: "", demoDate: ""
    });

    const [id, setID] = useState(null)

    let date = []

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getDates());
    }, [dispatch, dates]);

    const submitHandler = (e) => {
        e.preventDefault();

        if(id) {
            dispatch(updateDates(id, dates));
            alert("Dates updated")
        } else {
            const assigning = Object.assign({}, dates)
            assigning.userID = localStorage.getItem("id")
            if(date.length >= 1) {
                alert("Only allowed to create one date")
            } else {
                dispatch(createDates(assigning));
                alert("Dates submitted")
            }
        }
        clearFields();
    }

    const handleDates = (date) => {
        const newDate = Object.assign({}, dates)

        newDate.progressDate = date.progressDate.split('T')[0];
        newDate.demoDate = date.demoDate.split('T')[0];
        newDate.userID = localStorage.getItem("id");

        setID(date._id)
        setDates(newDate);
    }

    const clearFields = () => {
        setID(null);
        setDates({progressDate: '', demoDate: ''});
    }

    const response = useSelector((state) => state.dates.data);
    if (response){
        date = Array.from(response);
    }

    return(
        <div>
            <AdminNav />
            <form id={id} onSubmit={ submitHandler }>
                <h1>Dates</h1>
                <label>
                    Date for progress presentation:
                    <input type="date" name="progressdate" label="ProgressDate" value={dates ? dates.progressDate : ''} onChange={(e) => setDates({...dates, progressDate: e.target.value})}></input>
                </label>
                <label>
                    Date for demonstration day:
                    <input type="date" name="demodate" label="DemoDate" value={dates ? dates.demoDate : ''} onChange={(e) => setDates({...dates, demoDate: e.target.value})}></input>
                </label>
                <input className="submitButton" type="submit" name="submit" onClick={() => updateDates(id, dates)}></input>
            </form>
            {!date.length ? <CircularProgress /> : (
                <Grid >
                    {date.map((d) => (
                        <Grid className="paper" key={d._id} item>
                            <p>Chosen progress date: {d.progressDate}</p> 
                            <p>Chosen demonstration date: {d.demoDate}</p>
                            <Button onClick={() => handleDates(d)}>
                                <EditIcon/>
                                Edit
                            </Button>
                            {/* <Button onClick={() => dispatch(deleteDates(date._id))}>
                                <DeleteIcon/>
                                Delete
                            </Button> */}
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default AdminDates